import React from 'react';

import styles from './style.module.scss';

const VerticalDivider = () => {
  return <section className={styles.divider} />;
};

export default VerticalDivider;
